<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="itemFormatCommande">

        <h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps">{{collaps == true ? '-' : '+'}} {{$t('i_FormatCommande')}}</h6>
            <span v-show="collaps">

                <!--Qte / Boite-->
                <b-row align-v="center">
                    <b-col class="aRight" cols="5" :xl="prixSize.xl">
                        <span class="txtSign">/ {{$t('i_Bte')}}</span>
                    </b-col>
                    <b-col cols="6" :xl="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" v-model="_QteParBoite"></s-currencyInput>
                        </b-row>
                    </b-col>
                </b-row>

                <!--Commande min-->
                <b-row align-v="center">
                    <b-col class="aRight" cols="5" :xl="prixSize.xl">
                        <span class="txtSign">{{$t('i_Commande')}}</span>
                    </b-col>
                    <b-col cols="6" :xl="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" :append="$t('i_Bte')" v-model="_CommandeMin"></s-currencyInput>
                        </b-row>
                    </b-col>
                </b-row>

                <div class="splitSpace"/>

                <!--Min 1-->
                <b-row align-v="center">
                    <b-col class="aRight" cols="5" :xl="prixSize.xl">
                        <span class="txtSign">{{$t('i_Min')}}</span>
                    </b-col>
                    <b-col cols="6" :xl="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMin1"></s-currencyInput>
                        </b-row>
                    </b-col>
                </b-row>

                <!--Max 1-->
                <b-row align-v="center">
                    <b-col class="aRight" cols="5" :xl="prixSize.xl">
                        <span class="txtSign">{{$t('i_Max')}}</span>
                    </b-col>
                    <b-col cols="6" :xl="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMax1"></s-currencyInput>
                        </b-row>
                    </b-col>
                </b-row>

                <div class="splitSpace"/>

                <!--Min / Max 2, 3, 4-->
                <b-row>
                    <b-col class="aRight" cols="5" :xl="prixSize.xl"></b-col>
                    <b-col cols="6" :xl="prixSize.prix">
                        <b-row><b-button class="btnMode MargeLeft15 MargeTop5" type="button" :variant="getTheme.warning" @mousedown="collapsMinMax = !collapsMinMax"><s-upDownArrow :status="collapsMinMax"></s-upDownArrow></b-button></b-row>
                    </b-col>
                </b-row>
                
                    <span v-show="collapsMinMax">
                        <!--Copy le 1 dans le 2, 3, 4-->
                        <b-row>
                            <b-col class="aRight" cols="5" :xl="prixSize.xl"></b-col>
                            <b-col cols="6" :xl="prixSize.prix">
                                <b-row><b-button class="btnMode MargeLeft15 MargeTop5" type="button" @click="copyMinMax()">{{$t('i_Copie')}}</b-button></b-row>
                            </b-col>
                        </b-row>

                        <div class="splitSpace"/>

                        <!--Min 2-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                                <span class="txtSign">{{$t('i_Min2')}}</span>
                            </b-col>
                            <b-col cols="6" :xl="prixSize.prix">
                                <b-row align-v="center">
                                    <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMin2"></s-currencyInput>
                                </b-row>
                            </b-col>
                        </b-row>

                        <!--Max 2-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                                <span class="txtSign">{{$t('i_Max2')}}</span>
                            </b-col>
                            <b-col cols="6" :xl="prixSize.prix">
                                <b-row align-v="center">
                                    <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMax2"></s-currencyInput>
                                </b-row>
                            </b-col>
                        </b-row>

                        <div class="splitSpace"/>

                        <!--Min 3-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                                <span class="txtSign">{{$t('i_Min3')}}</span>
                            </b-col>
                            <b-col cols="6" :xl="prixSize.prix">
                                <b-row align-v="center">
                                    <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMin3"></s-currencyInput>
                                </b-row>
                            </b-col>
                        </b-row>

                        <!--Max 3-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                                <span class="txtSign">{{$t('i_Max3')}}</span>
                            </b-col>
                            <b-col cols="6" :xl="prixSize.prix">
                                <b-row align-v="center">
                                    <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMax3"></s-currencyInput>
                                </b-row>
                            </b-col>
                        </b-row>

                        <div class="splitSpace"/>

                        <!--Min 4-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                                <span class="txtSign">{{$t('i_Min4')}}</span>
                            </b-col>
                            <b-col cols="6" :xl="prixSize.prix">
                                <b-row align-v="center">
                                    <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMin4"></s-currencyInput>
                                </b-row>
                            </b-col>
                        </b-row>

                        <!--Max 4-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="5" :xl="prixSize.xl">
                                <span class="txtSign">{{$t('i_Max4')}}</span>
                            </b-col>
                            <b-col cols="6" :xl="prixSize.prix">
                                <b-row align-v="center">
                                    <s-currencyInput class="Prix" :append="$t('i_Un')" v-model="_QteMax4"></s-currencyInput>
                                </b-row>
                            </b-col>
                        </b-row>
                    </span>
            </span><!--FIN - Format de commande-->

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemFormatCommande',
    components: {
        
},
    props: ['prixSize', 'QteParBoite', 'CommandeMin',
            'QteMin1', 'QteMax1', 
            'QteMin2', 'QteMax2', 
            'QteMin3', 'QteMax3', 
            'QteMin4', 'QteMax4'],
    data() {
        return {
            collaps: false,
            collapsMinMax: false
        }
    },
    methods: {
        copyMinMax(){
            this._QteMin2 = this._QteMin1
            this._QteMax2 = this._QteMax1
            this._QteMin3 = this._QteMin1
            this._QteMax3 = this._QteMax1
            this._QteMin4 = this._QteMin1
            this._QteMax4 = this._QteMax1
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
        _QteParBoite: {
            get: function() {return this.QteParBoite},
            set: function(modifiedValue){this.$emit('update:QteParBoite', modifiedValue)}
        },
        _CommandeMin: {
            get: function() {return this.CommandeMin},
            set: function(modifiedValue){this.$emit('update:CommandeMin', modifiedValue)}
        },
        _QteMin1: {
            get: function() {return this.QteMin1},
            set: function(modifiedValue){this.$emit('update:QteMin1', modifiedValue)}
        },
        _QteMax1: {
            get: function() {return this.QteMax1},
            set: function(modifiedValue){this.$emit('update:QteMax1', modifiedValue)}
        },
        _QteMin2: {
            get: function() {return this.QteMin2},
            set: function(modifiedValue){this.$emit('update:QteMin2', modifiedValue)}
        },
        _QteMax2: {
            get: function() {return this.QteMax2},
            set: function(modifiedValue){this.$emit('update:QteMax2', modifiedValue)}
        },
        _QteMin3: {
            get: function() {return this.QteMin3},
            set: function(modifiedValue){this.$emit('update:QteMin3', modifiedValue)}
        },
        _QteMax3: {
            get: function() {return this.QteMax3},
            set: function(modifiedValue){this.$emit('update:QteMax3', modifiedValue)}
        },
        _QteMin4: {
            get: function() {return this.QteMin4},
            set: function(modifiedValue){this.$emit('update:QteMin4', modifiedValue)}
        },
        _QteMax4: {
            get: function() {return this.QteMax4},
            set: function(modifiedValue){this.$emit('update:QteMax4', modifiedValue)}
        }
        
    }
}
</script>

<style lang="scss" scoped>

</style>